<template>
  <TimeEntriesBaseSelectFilter
    class="client-type-filter"
    label="Source"
    placeholder="All sources"
    :options="clientTypeOptions"
    query-property="client_types"
    multiple
    @filter-change="onChange"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'TimeEntriesClientTypeFilter',
  computed: {
    ...mapGetters(['clientTypeOptions', 'tableColumns']),
  },
  methods: {
    ...mapActions(['updateTableColumns']),
    onChange(filters) {
      if (filters.client_types.length) {
        this.updateTableColumns({ ...this.tableColumns, show_source: true });
      }
    },
  },
};
</script>
